import cx from 'classnames';
import { Select } from '@components/select/Select';
import styles from './FloorPlanSelector.scss';
import { FloorPlanData } from '@shared/types/floorPlans';

interface FloorPlanSelectorProps {
  floorPlans: FloorPlanData[];
  selectedFloorPlan: FloorPlanData;
  onChange: (selectedFloorPlanId: string) => void;
  fullWidth?: boolean;
}

export const FloorPlanSelector = ({
  floorPlans,
  selectedFloorPlan,
  onChange,
  fullWidth = false,
}: FloorPlanSelectorProps) => {
  if (floorPlans.length < 2) return null;

  return (
    <Select
      aria-label="floor plan selector"
      className={cx(styles.floorPlanSelector, {
        [styles.fullWidth]: fullWidth,
      })}
      options={floorPlans.map((fp) => ({
        label: fp.name,
        value: fp.id,
      }))}
      defaultValue={selectedFloorPlan.id}
      value={selectedFloorPlan.id}
      onChange={(_, value) => {
        if (value) {
          onChange(value!);
        }
      }}
    />
  );
};
